import { Color } from 'three';

import { LumberTreatmentType } from '@paragon/contract-library';

type LumberColors = {
  [species: string]: {
    [grade: string]: {
      [K in LumberTreatmentType]?: Color;
    };
  };
};

export const defaultColor = new Color(0xf5f5f5);

export const lumberColorsFromProperties: LumberColors = {
  Southern_Pine: {
    Dense_Select_Structural: {
      ACQ: new Color(0xff8000),
      Borate: new Color(0xffe9e9),
      FireRetardantUnknown: new Color(0x9595ea),
      Untreated: new Color(0xbdb76b),
    },
    MSR_1650f_1_5E: {
      ACQ: new Color(0x6f006f),
      Borate: new Color(0xcc6600),
      FireRetardantUnknown: new Color(0x007d00),
      Untreated: new Color(0xa8d0db),
    },
    MSR_2100f_1_8E: {
      ACQ: new Color(0x8b008b),
      Borate: new Color(0xff8000),
      FireRetardantUnknown: new Color(0x6cad02),
      Untreated: new Color(0x6dbfb8),
    },
    MSR_2400f_2_0E: {
      ACQ: new Color(0xae00ae),
      Borate: new Color(0xffa040),
      FireRetardantUnknown: new Color(0x00e04f),
      Untreated: new Color(0x308ca6),
    },
    MSR_2850f_2_3E: {
      ACQ: new Color(0xda00da),
      Borate: new Color(0xffc890),
      FireRetardantUnknown: new Color(0x9eff1f),
      Untreated: new Color(0x346d9f),
    },
    Number_1: {
      ACQ: new Color(0x9595ea),
      Borate: new Color(0xa2ffad),
      FireRetardantUnknown: new Color(0xf8ff8d),
      Untreated: new Color(0x00bfff),
    },
    Number_2: {
      ACQ: new Color(0xc1feff),
      Borate: new Color(0x80ff00),
      FireRetardantUnknown: new Color(0x00ffbf),
      Untreated: new Color(0x00ff80),
    },
    Number_3: {
      ACQ: new Color(0x696969),
      Borate: new Color(0xff00bf),
      FireRetardantUnknown: new Color(0xbf00ff),
      Untreated: new Color(0xffff00),
    },
    Select_Structural: {
      ACQ: new Color(0x7fffd4),
      Borate: new Color(0xb8860b),
      FireRetardantUnknown: new Color(0x8b4513),
      Untreated: new Color(0xff7f50),
    },
  },
  Hem_Fir: {
    MSR_1650f_1_5E: {
      ACQ: new Color(0x6f006f),
      Borate: new Color(0xcc6600),
      FireRetardantUnknown: new Color(0x007d00),
      Untreated: new Color(0xa8d0db),
    },
    MSR_2100f_1_8E: {
      ACQ: new Color(0x8b008b),
      Borate: new Color(0xff8000),
      FireRetardantUnknown: new Color(0x6cad02),
      Untreated: new Color(0x6dbfb8),
    },
    MSR_2400f_2_0E: {
      ACQ: new Color(0xae00ae),
      Borate: new Color(0xffa040),
      FireRetardantUnknown: new Color(0x00e04f),
      Untreated: new Color(0x308ca6),
    },
    MSR_2850f_2_3E: {
      ACQ: new Color(0xda00da),
      Borate: new Color(0xffc890),
      FireRetardantUnknown: new Color(0x9eff1f),
      Untreated: new Color(0x346d9f),
    },
    Number_1: {
      ACQ: new Color(0x9595ea),
      Borate: new Color(0xa2ffad),
      FireRetardantUnknown: new Color(0xf8ff8d),
      Untreated: new Color(0x00bfff),
    },
    Number_2: {
      ACQ: new Color(0xc1feff),
      Borate: new Color(0x80ff00),
      FireRetardantUnknown: new Color(0x00ffbf),
      Untreated: new Color(0x00ff80),
    },
    Number_3: {
      ACQ: new Color(0x696969),
      Borate: new Color(0xff00bf),
      FireRetardantUnknown: new Color(0xbf00ff),
      Untreated: new Color(0xffff00),
    },
    Select_Structural: {
      ACQ: new Color(0x7fffd4),
      Borate: new Color(0xb8860b),
      FireRetardantUnknown: new Color(0x8b4513),
      Untreated: new Color(0xff7f50),
    },
  },
  Douglas_Fir_Larch: {
    MSR_1650f_1_5E: {
      ACQ: new Color(0x6f006f),
      Borate: new Color(0xcc6600),
      FireRetardantUnknown: new Color(0x007d00),
      Untreated: new Color(0xa8d0db),
    },
    MSR_2100f_1_8E: {
      ACQ: new Color(0x8b008b),
      Borate: new Color(0xff8000),
      FireRetardantUnknown: new Color(0x6cad02),
      Untreated: new Color(0x6dbfb8),
    },
    MSR_2400f_2_0E: {
      ACQ: new Color(0xae00ae),
      Borate: new Color(0xffa040),
      FireRetardantUnknown: new Color(0x00e04f),
      Untreated: new Color(0x308ca6),
    },
    MSR_2850f_2_3E: {
      ACQ: new Color(0xda00da),
      Borate: new Color(0xffc890),
      FireRetardantUnknown: new Color(0x9eff1f),
      Untreated: new Color(0x346d9f),
    },
    Number_1: {
      ACQ: new Color(0x9595ea),
      Borate: new Color(0xa2ffad),
      FireRetardantUnknown: new Color(0xf8ff8d),
      Untreated: new Color(0x00bfff),
    },
    Number_2: {
      ACQ: new Color(0xc1feff),
      Borate: new Color(0x80ff00),
      FireRetardantUnknown: new Color(0x00ffbf),
      Untreated: new Color(0x00ff80),
    },
    Number_3: {
      ACQ: new Color(0x696969),
      Borate: new Color(0xff00bf),
      FireRetardantUnknown: new Color(0xbf00ff),
      Untreated: new Color(0xffff00),
    },
    Select_Structural: {
      ACQ: new Color(0x7fffd4),
      Borate: new Color(0xb8860b),
      FireRetardantUnknown: new Color(0x8b4513),
      Untreated: new Color(0xff7f50),
    },
  },
  Spruce_Pine_Fir: {
    MSR_1650f_1_5E: {
      ACQ: new Color(0x6f006f),
      Borate: new Color(0xcc6600),
      FireRetardantUnknown: new Color(0x007d00),
      Untreated: new Color(0xa8d0db),
    },
    MSR_2100f_1_8E: {
      ACQ: new Color(0x8b008b),
      Borate: new Color(0xff8000),
      FireRetardantUnknown: new Color(0x6cad02),
      Untreated: new Color(0x6dbfb8),
    },
    MSR_2400f_2_0E: {
      ACQ: new Color(0xae00ae),
      Borate: new Color(0xffa040),
      FireRetardantUnknown: new Color(0x00e04f),
      Untreated: new Color(0x308ca6),
    },
    MSR_2850f_2_3E: {
      ACQ: new Color(0xda00da),
      Borate: new Color(0xffc890),
      FireRetardantUnknown: new Color(0x9eff1f),
      Untreated: new Color(0x346d9f),
    },
    Number_1: {
      ACQ: new Color(0x9595ea),
      Borate: new Color(0xa2ffad),
      FireRetardantUnknown: new Color(0xf8ff8d),
      Untreated: new Color(0x00bfff),
    },
    Number_2: {
      ACQ: new Color(0xc1feff),
      Borate: new Color(0x80ff00),
      FireRetardantUnknown: new Color(0x00ffbf),
      Untreated: new Color(0x00ff80),
    },
    Number_3: {
      ACQ: new Color(0x696969),
      Borate: new Color(0xff00bf),
      FireRetardantUnknown: new Color(0xbf00ff),
      Untreated: new Color(0xffff00),
    },
    Select_Structural: {
      ACQ: new Color(0x7fffd4),
      Borate: new Color(0xb8860b),
      FireRetardantUnknown: new Color(0x8b4513),
      Untreated: new Color(0xff7f50),
    },
  },
};
